export default __webpack_public_path__ + "static/media/element_56.2ebc7ee1.webp";